import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

interface TopHospitalStatTileProps {
    name: string | undefined;
    scanCount: number | undefined;
    isLoading: boolean;
    isError: boolean;
}

export function TopHospitalStatTile({
    name,
    scanCount,
    isLoading,
    isError,
}: TopHospitalStatTileProps) {
    return (
        <Paper sx={{ p: 3, flex: '1 1 220px', minWidth: 220 }}>
            <Typography variant="body2" color="text.secondary">
                Top hospital by scans
            </Typography>
            {isLoading ? (
                <Skeleton variant="text" width={140} height={32} sx={{ mt: 1 }} />
            ) : isError || !name ? (
                <Typography variant="h6" color="text.disabled" sx={{ mt: 0.5 }}>
                    {isError ? '—' : 'No scans yet'}
                </Typography>
            ) : (
                <>
                    <Typography variant="h6" sx={{ mt: 0.5, fontWeight: 600 }}>
                        {name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {scanCount} scan{scanCount === 1 ? '' : 's'}
                    </Typography>
                </>
            )}
        </Paper>
    );
}
